import { handleActions } from 'redux-actions'
import { defineAction } from 'redux-define'
import { fetchAllowance } from 'api'
import get from 'lodash/get'

const initialState = {
  data: [],
  logoUrl: '',
  name: '',
  isLoading: false,
}

const TYPES = ['FAILURE', 'SUCCESS', 'REQUEST']

const FETCH_ALLOWANCE_STATE = defineAction(
  'FETCH_ALLOWANCE_STATE',
  TYPES,
  'unicorn/allowance',
)

export const fetchAllowanceState = () => async (dispatch) => {
  try {
    console.log('fetching allowance state...')
    dispatch({ type: FETCH_ALLOWANCE_STATE.REQUEST })

    const allowanceData = await fetchAllowance()

    dispatch({
      type: FETCH_ALLOWANCE_STATE.SUCCESS,
      payload: allowanceData,
    })
  } catch (err) {
    dispatch({
      type: FETCH_ALLOWANCE_STATE.FAILURE,
    })
  }
}

export default handleActions(
  {
    [FETCH_ALLOWANCE_STATE.REQUEST]: (state) => ({
      ...state,
      isLoading: true,
    }),
    [FETCH_ALLOWANCE_STATE.SUCCESS]: (state, { payload }) => ({
      ...state,
      data: get(payload, 'allowances', []),
      logoUrl: get(payload, 'logoUrl', ''),
      name: get(payload, 'name', ''),
      isLoading: false,
    }),
    [FETCH_ALLOWANCE_STATE.FAILURE]: (state) => ({
      ...state,
      isLoading: false,
    }),
  },
  initialState,
)
